import { message } from 'antd';
import { AppInsights } from "applicationinsights-js";

import * as t from './actionTypes';
import * as constants from './constants';
import common from '../../common';

export function setSelectedYear(year) {
    return {
        type: t.SET_INCIDENTS_SELECTEDYEAR,
        payload: year
    };
}
export function setSelectedDetailIncidentIsDirty(isdirty) {
    return {
        type: t.SET_SELECTED_DETAIL_INCIDENT_DIRTY,
        payload: isdirty
    };
}

export function loadIncidents(year) {
    return async (dispatch, getState) => {
        dispatch({
            type: t.INCIDENTS_LOADING,
            payload: true
        })
        let lang = getState().uistate.appsettings.lang

        const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/incidents?year=${year}&lang=${lang}`);
        dispatch({
            type: t.LOAD_INCIDENTS,
            payload: resp.data
        });
        dispatch({
            type: t.INCIDENTS_LOADING,
            payload: false
        });
    };
}

export function clearSelectedDetailIncident() {
    return async (dispatch, getState) => {
        dispatch({
            type: t.LOAD_INCIDENTDETAILS,
            payload: {}
        });
    };
}

export function loadIncidentDetails(idIncident) {
    return async (dispatch, getState) => {
        dispatch({
            type: t.DETAILS_LOADING,
            payload: true
        });
        const lang = getState().uistate.appsettings.lang
        try {
            const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/incidents/details/${idIncident}?lang=${lang}`);
            dispatch({
                type: t.LOAD_INCIDENTDETAILS,
                payload: resp.data
            });
            dispatch({
                type: t.DETAILS_LOADING,
                payload: false
            });
            return resp.data;
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}

export function createNewIncident(values) {
    return async (dispatch, getState) => {
        const resp = await common.apiClient.post(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/incidents`, values);
        return resp.data
    };
}

export function updateIncidentDetails(incident) {
    return async (dispatch, getState) => {
        try {
            const resp = await common.apiClient.put(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/incidents`, incident);
            message.success('data saved.');
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}

export function deleteIncident(idincident) {
    return async (dispatch, getState) => {
        try {
            const resp = await common.apiClient.delete(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/incidents/${idincident}`);
            message.success('record deleted.');
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}

//#region File-actions

export function uploadIncidentFile(file, idIncident) {
    return async function (dispatch, getState) {
        try {
            //formdata en header instellen
            const formData = new FormData();
            formData.append('file', file);

            const config = {
                headers: {
                    'content-type': 'multipart/form-data',
                },
            };

            await common.apiClient.post(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/files/upload/incident/${idIncident}`, formData, config)
        } catch (error) {
            message.error('Error saving file (to big?).', 5)
            AppInsights.trackException(error);
        }
    };
}

export function getLinkedFile(idLinkedIncidentFile) {
    return async function (dispatch, getState) {
        try {
            let resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/files/download/incident/${idLinkedIncidentFile}`);
            return resp.data;
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}

//#endregion
